"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.translationNamespace = exports.analyticsFactory = exports.measureFactory = exports.filterFactory = exports.createFilterMatcher = void 0;
require("./translation/initialize-i18n.js");
/**
 * @packageDocumentation
 * @group Factories
 * Functions for creating measures, filters, and advanced analytics elements.
 * @group Data Model Utilities
 * Utility functions for creating attributes and dimensions in code.
 */
__exportStar(require("./interfaces.js"), exports);
__exportStar(require("./dimensional-model/types.js"), exports);
__exportStar(require("./dimensional-model/interfaces.js"), exports);
__exportStar(require("./dimensional-model/base.js"), exports);
__exportStar(require("./dimensional-model/data-model.js"), exports);
__exportStar(require("./dimensional-model/attributes.js"), exports);
__exportStar(require("./dimensional-model/dimensions/index.js"), exports);
__exportStar(require("./dimensional-model/factory.js"), exports);
__exportStar(require("./dimensional-model/jaql-element.js"), exports);
__exportStar(require("./dimensional-model/filters/filters.js"), exports);
__exportStar(require("./dimensional-model/filters/filter-config-utils.js"), exports);
var filter_matcher_utils_js_1 = require("./dimensional-model/filters/utils/filter-matcher-utils.js");
Object.defineProperty(exports, "createFilterMatcher", { enumerable: true, get: function () { return filter_matcher_utils_js_1.createFilterMatcher; } });
/**
 * Functions to create date, text, or numeric filters on specified data.
 *
 * Filters created with these functions can be used to:
 *
 * + Filter explicit queries by query components or query functions
 * + Filter or highlight queries used by UI components, such as charts
 * + Set the filters of filter components
 *
 * @example
 * Example of using React hook `useExecuteQuery` to query the `Sample ECommerce` data source.
 * Factory function `filterFactory.greaterThan()` is used to create a filter on `Revenue` to get values
 * greater than 1000.
 * ```tsx
 *   const { data, isLoading, isError } = useExecuteQuery({
 *     dataSource: DM.DataSource,
 *     dimensions: [DM.Commerce.AgeRange],
 *     measures: [measureFactory.sum(DM.Commerce.Revenue)],
 *     filters: [filterFactory.greaterThan(DM.Commerce.Revenue, 1000)],
 *   });
 *   if (isLoading) {
 *     return <div>Loading...</div>;
 *   }
 *   if (isError) {
 *     return <div>Error</div>;
 *   }
 *   if (data) {
 *     return <div>{`Total Rows: ${data.rows.length}`}</div>;
 *   }
 *   return null;
 * ```
 * @group Factories
 */
exports.filterFactory = __importStar(require("./dimensional-model/filters/factory.js"));
__exportStar(require("./dimensional-model/measures/measures.js"), exports);
/**
 * Functions to create measures that aggregate, summarize, and accumulate data,
 * plus show changes in data over time.
 *
 * Measures created with these functions can be used in the data options of UI components such as
 * {@link @sisense/sdk-ui!ChartProps | Chart}, {@link @sisense/sdk-ui!ChartWidgetProps | ChartWidget},
 * and {@link @sisense/sdk-ui!ExecuteQueryProps | ExecuteQuery}.
 *
 * @example
 * Example of using React hook useExecuteQuery to query the `Sample ECommerce` data source.
 * Factory function `measureFactory.sum()` is used to create a measure that sums the `Revenue` column.
 * ```tsx
 *   const { data, isLoading, isError } = useExecuteQuery({
 *     dataSource: DM.DataSource,
 *     dimensions: [DM.Commerce.AgeRange],
 *     measures: [measureFactory.sum(DM.Commerce.Revenue)],
 *     filters: [filterFactory.greaterThan(DM.Commerce.Revenue, 1000)],
 *   });
 *   if (isLoading) {
 *     return <div>Loading...</div>;
 *   }
 *   if (isError) {
 *     return <div>Error</div>;
 *   }
 *   if (data) {
 *     return <div>{`Total Rows: ${data.rows.length}`}</div>;
 *   }
 *   return null;
 * ```
 * @group Factories
 */
exports.measureFactory = __importStar(require("./dimensional-model/measures/factory.js"));
__exportStar(require("./dimensional-model/simple-column-types.js"), exports);
/**
 * Functions to create elements for advanced analytics – for example, attributes and measures for constructing a custom Boxplot chart
 *
 * @group Factories
 */
exports.analyticsFactory = __importStar(require("./dimensional-model/analytics/factory.js"));
__exportStar(require("./utils.js"), exports);
__exportStar(require("./dimensional-model/filters/index.js"), exports);
var index_js_1 = require("./translation/resources/index.js");
Object.defineProperty(exports, "translationNamespace", { enumerable: true, get: function () { return index_js_1.PACKAGE_NAMESPACE; } });
